import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";
import LoopWinsMediator from "slotworks/mediators/loop-wins-mediator";
import State from "slotworks/state-machine/states/state";

export default class LoopWins extends State {

    private loopWinsMediator: LoopWinsMediator;

    public onEnter() {
        this.loopWinsMediator = new LoopWinsMediator();

        this.loopWinsMediator.start().then(() => this.complete());
    }

    public onSkip() {
        this.loopWinsMediator.end().then(() => this.skip());
    }

    public onExit() {
        StaticSymbolsCommand().execute();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/loop-wins.ts